export function isSessionTerminatedError(error) {
  return (
    error?.response?.status === 401 &&
    error.response.data?.code === "SESSION_TERMINATED"
  );
}

export function handleRefreshTokenError(error, logout) {
  if (!isSessionTerminatedError(error)) {
    logout();
  }
}
